export enum FilterType {
    MultiSelect,
    TagSearch,
    Date
}
